export default {
	headerSearch: {
  "preferences": "Tema e idioma",
  "collapsed": "Buscar…",
  "open": "Buscar pessoas e guias",
  "placeholder": "Consulente, médium ou guia…",
  "hint": "Digite pelo menos 2 caracteres.",
  "empty": "Nenhum resultado encontrado.",
  "error": "Não foi possível carregar todos os resultados. Tente novamente.",
  "limit": "Até 5 resultados por categoria. Refine o nome para encontrar mais.",
  "primaryMedium": "Médium principal: {name}",
  "noPrimary": "Sem médium principal",
  "consulente": "Consulente",
  "medium": "Médium",
  "guide": "Guia"
},
	active: "Ativo",
	inactive: "Inativo",
	status: "Status",
	actions: "Ações",
	notFinished: "Não finalizado",
	save: "Salvar",
	cancel: "Cancelar",
	edit: "Editar",
	delete: "Excluir",
	create: "Criar",
	update: "Atualizar",
	add: "Adicionar",
	change: "Alterar",
	remove: "Remover",
	close: "Fechar",
	typeToSearch: "Digite para pesquisar",
	years: "anos",
	view: "Visualizar",
	details: "Detalhes",
	loading: "Carregando...",
	loadMore: "Carregar mais",
	search: "Pesquisar",
	searchField: "Busca",
	filter: "Filtrar",
	print: "Imprimir",
	createdAt: "Criado em",
	description: "Descrição",
	notes: "Observações",
	endedAt: "Finalizado em",
	notSpecified: "Não especificado",
	activate: "Ativar",
	deactivate: "Desativar",
	since: "Desde",
	showActiveOnly: "Mostrar apenas ativos",
	confirmDelete: "Confirmar Exclusão",
	all: "Todos",
	back: "Voltar",
	next: "Próximo",
	showMore: "Mostrar mais",
	showLess: "Mostrar menos",
	error: "Erro ao realizar operação",
	errorLoading: "Erro ao carregar dados",
	errorSaving: "Erro ao salvar dados",
	unknown: "Desconhecido",
	unnamed: "Sem nome",
	yes: "Sim",
	no: "Não",
	start: "Iniciar",
	complete: "Concluir",
	createdBy: "Criado por",
	lastUpdate: "Última atualização",
	confirm: "Confirmar",
	timestamps: "Datas do Sistema",
	viewDetails: "Ver Detalhes",
	invalidValue: "Valor inválido",
	required: "Campo obrigatório",
	saved: "Salvo com sucesso",
	optional: "opcional",
};
